import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.4_@playwright+test@1.57.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/old-site.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ads/ads-banner-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ads/ads-section/components/ads-banner-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/articles/articlecard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/articles/category-tab/article-list-control-mock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/business/business-ads-media.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/event-calendar/event-calendar-component-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/gallery/dialog-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/gallery/gallery-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/gallery/member-travel-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/hall-of-fame/hall-of-fame-list-dialog-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/hall-of-fame/hall-of-fame-list-loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/cart/cart-main-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/collections/collection-list-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollectionListPageSizeSelectionClient","default"] */ "/app/src/components/collections/collection-list-order-selection-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/collections/collection-page-control-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/collections/related-collection-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/controls/favorite-button-lazyLoad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/dynamic-form/dynamic-form-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/dynamic-form/dynamic-form-sever.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/faq/top-faqs-component-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/faq/top-faqs-load.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/faq/top-faqs.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/horizontal-card/components/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/horizontal-shortcut-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/horizontal-shortcut-loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/how-to-shop/step-information.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/payment/payment-main-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product-highlight/product-highlight-type1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product-highlight/product-highlight-type2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/product-showboxes-product-list-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/product-showboxes-tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/product-header-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/product-promotion-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/product-promotion-list-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/product-related-item-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/tab-navigator-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/selections/collection-list-tag-filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/share-format/article-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shelve-article_banner_loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shelve-monthly-promotion-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shelvepromotion1-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shelvesubsccriptionads-favorite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shelvesubsccriptionads-loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Tooltip/custom-tooltip-lazyLoad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleRecaptchaProvider"] */ "/app/src/lib/providers/google-recaptcha.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/util/iFrameLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/util/ScriptRunnerEditor.tsx");
